import Vue from 'vue'
import Vuex from 'vuex'
import VueAxios from 'vue-axios'
import axios from 'axios';


Vue.use(Vuex);
Vue.use(VueAxios, axios);

const store = new Vuex.Store({
    strict: true,
});

export default store;